import { Client } from '@stomp/stompjs';

export class Websocket {
  constructor({ url }) {
    this.client = null;
    this.isConnected = false;
    this.subscribtions = [];
    this.data = {};

    if (!this.isConnected) {
      this.client = new Client();
      this.client.brokerURL = url;
      this.registerEvents();
      this.client.activate();
    }
  }

  // Public methods
  subscribe(paths = [], onMessage, isRememberData = true) {
    const ids = [];
    if (this.isConnected && paths.length > 0) {
      paths.forEach((path) => {
        const subscribtion = this.client.subscribe(path, (msg) => {
          if (isRememberData) {
            if (this.data[path]) {
              this.data[path].push(JSON.parse(msg.body));
            } else {
              this.data[path] = [JSON.parse(msg.body)];
            }
          }
          onMessage(JSON.parse(msg.body));
        });
        this.subscribtions.push({ id: subscribtion.id, path });
        ids.push(subscribtion.id);
      });
    }
    return ids;
  }

  subscribeOne(path, onMessage, isRememberData = true) {
    if (this.isConnected && !this.subscribtions.find((subscribtion) => subscribtion.path === path)) {
      const subscribtion = this.client.subscribe(path, (msg) => {
        if (isRememberData) {
          if (this.data[path]) {
            this.data[path].push(JSON.parse(msg.body));
          } else {
            this.data[path] = [JSON.parse(msg.body)];
          }
        }
        onMessage(JSON.parse(msg.body));
      });
      this.subscribtions.push({ id: subscribtion.id, path });
    }
  }

  unsubscribe(path) {
    const subscribtions = this.subscribtions.filter((subscribtion) => subscribtion.path === path);
    if (subscribtions.length > 0) {
      subscribtions.forEach((subscribtion) => {
        const findIndex = this.subscribtions.findIndex((s) => s.path === path);
        this.client.unsubscribe(subscribtion.id);
        this.subscribtions.splice(findIndex, 1);
      });
    }
  }

  // Private methods
  registerEvents() {
    this.client.onConnect = () => {
      console.log('%c ws connected', 'color: limegreen');
      this.isConnected = true;
    };

    this.client.onDisconnect = () => {
      console.log('%c ws disconnected', 'color: crimson');
      this.isConnected = false;
    };

    this.client.onWebSocketClose = () => {
      console.log('%c ws closed', 'color: darkgrey');
      this.isConnected = false;
    };
  }
}
